import React, { useState } from "react";
import { PopupButton } from "react-calendly";
import booking from "../assets/about/book.jpg";

const Booking = () => {
  const [selectedUser, setSelectedUser] = useState("");

  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
  };

  const getPopupButtonProps = () => {
    if (selectedUser === "") {
      return {
        className: "text-white underline underline-offset-4 cursor-not-allowed",
        url: "/",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "wanyue") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/wanyue-wang?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "arlen") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/arlen-wang-1?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "claire") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/claire_cai?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "david") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/nzdwang?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "eccles") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/eccles-chan?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "annatta") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/annatta-yi?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "alice") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/alice-xu-2?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    } else if (selectedUser === "roger") {
      return {
        className: "text-white hover:scale-110 underline underline-offset-4",
        url: "https://calendly.com/roger_shen?hide_gdpr_banner=1&text_color=4b4747&primary_color=ed1c24",
        rootElement: document.getElementById("root"),
        text: "Click here to schedule!",
      };
    }
    return null;
  };

  const popupButtonProps = getPopupButtonProps();

  return (
    <div className="bg-white">
      <head>
        <meta
          name="description"
          content="We offer an easy and convenient way to reserve your time slot with our mortgage broker online"
        />
        <meta
          property="og:site_name"
          content="Book a chat online - Bicare Finance"
        />
        <meta
          property="og:title"
          content="Book a chat online - Bicare Finance"
        />
        <meta property="og:locale" content="en-NZ" />
        <meta
          property="og:description"
          content="We offer an easy and convenient way to reserve your time slot with our mortgage broker online"
        />
        <meta
          name="twitter:title"
          content="Book a chat online - Bicare Finance"
        />
        <meta
          name="twitter:description"
          content="We offer an easy and convenient way to reserve your time slot with our mortgage broker online"
        />
        <title>Book a chat online - Bicare Finance</title>
        <link rel="canonical" href="https://bicare.co.nz/booking" />
      </head>
      <div className="relative bg-gray-900">
        <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
          <img
            src={booking}
            alt="Book a meeting with a professional Bicare mortgage broker"
            className="h-full w-full object-cover object-center"
          />
        </div>
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gray-900 opacity-70"
        />

        <div className="relative mx-auto flex max-w-3xl flex-col items-center py-32 px-6 text-center sm:py-64 lg:px-0">
          <h1 className="text-4xl font-bold tracking-tight text-white lg:text-5xl">
            Ready to talk to a Mortgage Broker expert?
          </h1>
          <p className="mt-4 text-xl text-white">
            It’s time to take control of your books. Whether you're looking to
            schedule a consultation, or any other type of appointment, we offer
            an easy and convenient way to reserve your time slot online.
          </p>
          <p className="mt-6 mb-6 text-white text-base">
            Our service is completely FREE!
          </p>
          <div>
            <select
              className="inline-flex mt-8 text-center justify-center rounded-lg py-3 px-12 text-md font-semibold hover:scale-105 bg-white text-gray-900"
              id="user-select"
              value={selectedUser}
              onChange={handleUserChange}
            >
              <option value="">Select a mortgage advisor</option>
              <option value="alice">Alice Xu</option>
              <option value="annatta">Annatta Yi</option>
              <option value="arlen">Arlen Wang</option>
              <option value="claire">Claire Cai</option>
              <option value="david">David Wang</option>
              <option value="eccles">Eccles Chan</option>
              <option value="roger">Roger Shen</option>
              <option value="wanyue">Wanyue Wang</option>
            </select>
            <div className="mt-8">
              {popupButtonProps && <PopupButton {...popupButtonProps} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
